"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoPlayer = exports.VideoPlayerDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var react_player_1 = __importDefault(require("react-player"));
exports.VideoPlayerDefaultProps = {
  aspectRatio: {
    base: 16 / 9
  },
  controls: true
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    display: flex;\n    ", "\n  "], ["\n    position: relative;\n    display: flex;\n    ", "\n  "])), function (props) {
    return props.aspectRatio && props.aspectRatio.base && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding-bottom: ", "%;\n    "], ["\n      padding-bottom: ", "%;\n    "])), 1 / props.aspectRatio.base * 100);
  }),
  landscape: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.aspectRatio && props.aspectRatio.landscape && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      padding-bottom: ", "%;\n    "], ["\n      padding-bottom: ", "%;\n    "])), 1 / props.aspectRatio.landscape * 100);
  }),
  tablet: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.aspectRatio && props.aspectRatio.tablet && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      padding-bottom: ", "%;\n    "], ["\n      padding-bottom: ", "%;\n    "])), 1 / props.aspectRatio.tablet * 100);
  }),
  desktop: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.aspectRatio && props.aspectRatio.desktop && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      padding-bottom: ", "%;\n    "], ["\n      padding-bottom: ", "%;\n    "])), 1 / props.aspectRatio.desktop * 100);
  }),
  desktopLarge: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.aspectRatio && props.aspectRatio.desktopLarge && (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      padding-bottom: ", "%;\n    "], ["\n      padding-bottom: ", "%;\n    "])), 1 / props.aspectRatio.desktopLarge * 100);
  })
});
var PlayerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    left: 0;\n  "], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Player: (0, styled_components_1.default)(react_player_1.default)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), PlayerStyles)
};
var VideoPlayer = function (props) {
  var className = props.className,
    aspectRatio = props.aspectRatio,
    playerProps = __rest(props, ["className", "aspectRatio"]);
  var ref = React.useRef(null);
  var handleReady = function () {
    var _a;
    var internal = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getInternalPlayer();
    if (internal instanceof HTMLVideoElement) {
      internal.setAttribute('controlsList', 'nodownload');
    }
  };
  return React.createElement(My.Container, {
    className: className,
    aspectRatio: aspectRatio
  }, React.createElement(My.Player, __assign({
    onReady: handleReady,
    ref: ref,
    width: "100%",
    height: "100%"
  }, playerProps)));
};
exports.VideoPlayer = VideoPlayer;
exports.VideoPlayer.defaultProps = exports.VideoPlayerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;